// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/~/core-js/modules/_is-array.js
// module id = ../../../../core-js/modules/_is-array.js
// module chunks = 0